import { render, staticRenderFns } from "./SubjectCreationPage.vue?vue&type=template&id=e93faf58&scoped=true&"
import script from "./SubjectCreationPage.vue?vue&type=script&lang=ts&"
export * from "./SubjectCreationPage.vue?vue&type=script&lang=ts&"
import style0 from "./SubjectCreationPage.vue?vue&type=style&index=0&id=e93faf58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93faf58",
  null
  
)

export default component.exports